function space(item) {
  return item?.replace(/,/g, ", ");
}

export default space;
